import React from "react";
import PropTypes from "proptypes";

const ItineraryPreviewModal = ({ closeModal, previewUrl }) => {
  return (
    <div className="col-md-12">
      <button className="square-icon right" onClick={closeModal}>
        X
      </button>
      <img
        className="documentsPreviewImage"
        src={previewUrl ? previewUrl : ""}
        alt="travel-document"
      />
    </div>
  );
};

ItineraryPreviewModal.propTypes = {
  closeModal: PropTypes.func.isRequired
};

export default ItineraryPreviewModal;
